<template>
  <div class="nx-linked-selectors-wrapper">
    <nx-select
      :error-messages="errorMessages"
      :label="getLabel(master)"
      :value="masterValue"
      @input="emitMasterValue"
      v-bind="master.params"
    ></nx-select>
    <nx-select
      :error-messages="errorMessages"
      :items="slaveItems"
      :label="getLabel(slave)"
      :value="slaveValue"
      @input="emitSlaveValue"
      v-bind="slave.params"
      v-if="showSlave"
    ></nx-select>
  </div>
</template>

<script>
import NxSelect from '@/components/selectors/Select';
import get from 'lodash/get';

export default {
  extends: {},
  mixins: [],
  components: { NxSelect },
  props: {
    master: {
      type: Object,
      required: true,
    },
    slave: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    errorMessages: {
      type: Array, required: false, default: () => ([]),
    },
    hideSlaveIfItemsEmpty: Boolean,
    autoSelectSlaveFirstValue: Boolean,
    disableSlaveAutoSelect: Boolean,
  },
  data() {
    return {};
  },
  computed: {
    masterValue() {
      if (!this.value) {
        return null;
      }
      return get(this.value, this.master.field, null);
    },
    slaveValue() {
      if (!this.value) {
        return null;
      }
      return get(this.value, this.slave.field, null);
    },
    slaveItems() {
      return this.getSlaveItems(this.masterValue);
    },
    showSlave() {
      return this.slaveItems.length > 0 || !this.hideSlaveIfItemsEmpty;
    },
  },
  methods: {
    emitMasterValue(value) {
      if (this.masterValue === value) {
        return;
      }

      const slaveValue = this.getSlaveValueFromMaster(value);

      const newValue = {
        [this.master.field]: value,
        [this.slave.field]: slaveValue,
      };
      this.$emit('input', newValue);
    },
    emitSlaveValue(value) {
      if (this.masterValue === value) {
        return;
      }
      const newValue = {
        ...this.value,
        ...{ [this.slave.field]: value },
      };
      this.$emit('input', newValue);
    },
    normalizeLocaleString(str) {
      return str.charAt(0).toLowerCase() + str.slice(1);
    },
    getLabel(fieldConfig) {
      const { label } = fieldConfig;
      if (!label) {
        return '';
      }
      const translationKey = `message.form.fields.${this.normalizeLocaleString(label)}`;
      if (this.$te(translationKey)) return this.$t(translationKey);
      console.log('Missing translation for field label:', translationKey);
      return label;
    },
    getSlaveItems(masterValue) {
      if (!masterValue) {
        return [];
      }
      return get(this.slave, `params.items.${masterValue}`, []);
    },
    getSlaveValueFromMaster(masterValue) {
      if (this.disableSlaveAutoSelect) {
        return null;
      }
      const slaveItems = this.getSlaveItems(masterValue);
      if (slaveItems.length === 0) {
        return null;
      }

      if (!this.autoSelectSlaveFirstValue && slaveItems.length !== 1) {
        return null;
      }

      const firstValue = slaveItems[0];
      return (typeof firstValue === 'string') ? firstValue : get(firstValue, 'value', null);
    },
  },
  beforeCreate() {
  },
  mounted() {
  },
};
</script>
